<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>프로모션 설정</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>키오스크 ID</label>
            <ul class="w75">
              <li>{{ kioskInfo.kioskNo }}</li>
            </ul>
          </dd>
          <dd>
            <label>생성일시</label>
            <ul class="w75">
              <li>{{ kioskInfo.frstRgstDt }}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>키오스크명</label>
            <ul class="w75">
              <li>{{ kioskInfo.kioskNm }}</li>
            </ul>
          </dd>
          <dd>
            <label>사용여부</label>
            <ul class="w75">
              <li>{{ kioskInfo.kioskUseYn }}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>사업장/거점</label>
            <ul class="w75">
              <li>{{ kioskInfo.facilityNm }}<span class="mgl10">{{ kioskInfo.areaNm }}</span></li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>건물/층</label>
            <ul class="w75">
              <li>{{ kioskInfo.buildingNm }}<span class="mgl10">{{ kioskInfo.floorNm }}</span></li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>프로모션 사용여부</label>
            <ul class="w75">
              <li>
                <kendo-switch
                    ref="kioskPromotionUseYnRef"
                    :messages-checked="'on'"
                    :messages-unchecked="'off'"
                    @change="promotionInfo.kioskPromotionUseYn = ((promotionInfo.kioskPromotionUseYn === 'Y') ? 'N' : 'Y')"
                    :checked="promotionInfo.kioskPromotionUseYn === 'Y'"
                >
                </kendo-switch>
              </li>
            </ul>
          </dd>
          <dd>
            <label>프로모션 시간 (초)</label>
            <ul class="w50">
              <li>
                <input
                    class="w100"
                    :class="{'error' : errorTarget === 'promotionDelay'}"
                    type="number"
                    ref="delayRef"
                    v-model="promotionInfo.promotionDelay"
                    @input="promotionInfo.promotionDelay = promotionInfo.promotionDelay.slice(0, 1)"
                    :placeholder="'딜레이 초를 입력하세요.'">
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  상단 버튼 영역  -->
    <div class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
                <button class="mid_btn green" @click="onClickAddRow">새 프로모션 추가</button> <b class="mgl10 txt_o">* 프로모션 이미지 사이즈 840*1495 </b>
        </div>
    </div>
    <!--  프로모션 리스트 영역  -->
    <div data-role="grid" class="mgt10 k-grid k-widget k-grid-display-block k-reorderable" style="cursor: pointer;">
      <div class="k-grid-header" style="padding-right: 17px;">
        <div class="k-grid-header-wrap k-auto-scrollable" data-role="resizable">
          <table role="grid">
          <colgroup>
            <col style="width:5%">
            <col style="width:10%">
            <col style="width:10%">
            <col style="width:10%">
            <col style="width:20%">
            <col style="width:20%">
            <col style="width:5%">
          </colgroup>
          <thead role="rowgroup">
          <tr role="row">
            <th scope="col" role="columnheader" data-field="seventhField" aria-haspopup="true" rowspan="1" data-title="좌석수(석)" data-index="6" id="c0ae6655-2fb3-4f87-9cf3-1f2cf5e562ef" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">삭제</th>
            <th scope="col" role="columnheader" data-field="fisrtField" aria-haspopup="true" rowspan="1" data-title="No." data-index="0" id="74747c93-b03b-4c75-99b5-965536c937dc" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">썸네일 미리보기<span class='forg'>*</span></th>
            <th scope="col" role="columnheader" data-field="secondField" aria-haspopup="true" rowspan="1" data-title="입주업체" data-index="1" id="ebcdaf82-628f-4e9a-bfff-1c255ae3870b" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">프로모션 이미지 첨부<span class='forg'>*</span></th>
            <th scope="col" role="columnheader" data-field="thirdField" aria-haspopup="true" rowspan="1" data-title="신청일" data-index="2" id="fa8f3980-4408-4a2f-9818-ff8f778410f9" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">표시순서</th>
            <th scope="col" role="columnheader" aria-haspopup="true" rowspan="1" data-title="진행상태" data-index="3" id="6bc4bdf4-9013-404e-adbd-e6127b19f235" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">액션 종류</th>
            <th scope="col" role="columnheader" data-field="fifthField" aria-haspopup="true" rowspan="1" data-title="계약기간" data-index="4" id="19305091-3fdd-4180-b521-460ff07d9810" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">액션 데이터</th>
            <th scope="col" role="columnheader" data-field="sixthField" aria-haspopup="true" rowspan="1" data-title="신청자" data-index="5" id="a1503403-c91a-4b93-b887-bde8490c23d5" style="font-weight: bold; text-align:center" class="k-header"
                data-role="droptarget">사용여부</th>
          </tr>
          </thead>
          </table>
        </div>
      </div>

      <div class="k-grid-content k-auto-scrollable">
        <table v-if="promotionList.length < 1" role="grid" style="height: auto;" data-role="selectable" class="k-selectable">
          <colgroup>
            <col style="width:100%">
          </colgroup>
          <tbody role="rowgroup">
          <tr role="row" class="k-text-center">
            <div class="mgt10">표시할 데이터가 없습니다.</div>
          </tr>
          </tbody>
        </table>
        <table v-else role="grid" style="height: auto;" data-role="selectable" class="k-selectable">
          <colgroup>
            <col style="width:5%">
            <col style="width:10%">
            <col style="width:10%">
            <col style="width:7%">
            <col style="width:20%">
            <col style="width:20%">
            <col style="width:5%">
          </colgroup>
          <tbody role="rowgroup">
          <tr role="row" v-for="item in promotionList" style="cursor:auto;">
            <td class="k-text-center" data-field="eighthField" role="gridcell">
              <kendo-button @click="onClickDeleteRow(item)">삭제</kendo-button>
            </td>
            <td class="k-text-center" data-field="fisrtField" role="gridcell">
              <img v-if="item.fileId === null && item.imgFile === null" style="height: 40px; border:1px solid #efefef" src="@/assets/img/etners-web/noimg.jpg">
              <img v-else style="height: 80px; border:1px solid #efefef" :src="getFileSrc(item)">
            </td>
            <td class="k-text-center" data-field="secondField" role="gridcell">
              <button @click="selectedRow = item">
                <send-file-upload
                    ref="fileUploadRef"
                    @child="getFileData"
                    v-bind:file="[]"
                ></send-file-upload>
              </button>
            </td>
            <td class="k-text-center" data-field="thirdField" role="gridcell">
                  <div>
                  <kendo-button
                      class="mid_btn"
                      type="button"
                      v-if="item.seqNo !='1'"
                      @click="upSeqNo(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="width:15px">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                  </kendo-button>
                  </div>
                  <div class="mgt5">
                  {{ item.seqNo }}
                  </div>
                  <div class="mgt5">
                   <kendo-button
                      class="mid_btn"
                      type="button"
                      v-if="promotionList.at(promotionList.length-1).seqNo != item.seqNo"
                      @click="downSeqNo(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="width:15px">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>
                  </kendo-button>
                  </div>
              </ul>
            </td>
            <td class="k-text-center" role="gridcell">
              <kendo-dropdownlist
                  class="w75"
                  ref="actionRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdNm'"
                  v-model="item.actionType"
                  :data-source="[{cdNm: 'REDIRECT_MAIN'}]"
                  :option-label="'액션 종류를 선택하세요'"
                  :disabled="true"
              >
              </kendo-dropdownlist>
            </td>
            <td class="k-text-center" data-field="fifthField" role="gridcell">
              <kendo-maskedtextbox
                  class="w100"
                  ref="actionDataRef"
                  :disabled="true"
                  :placeholder="'액션 데이터를 입력하세요.'">
              </kendo-maskedtextbox>
            </td>
            <td class="k-text-center" data-field="seventhField" role="gridcell">
              <kendo-switch
                  ref="autoYnRef"
                  :messages-checked="'on'"
                  :messages-unchecked="'off'"
                  @change="item.promotionUseYn = ((item.promotionUseYn === 'Y') ? 'N' : 'Y')"
                  :checked="item.promotionUseYn === 'Y'"
                  :id="'promotionUseYn_'+(item.prId + 1)"
              >
              </kendo-switch>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--  하단 버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25"><button class="large_btn orange" @click="onClickSave">저장</button></li>
        <li class="w25"><button class="large_btn" @click="redirectToList">목록</button></li>
      </ul>
    </div>
  </section>
</template>
<script>
import $ from 'jquery';
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import SendFileUpload from "@/components/send/SendFileUpload.vue";
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "PromotionSettings",
  components: {SendFileUpload},
  created() {
    const vm = this
    vm.getKioskDetail()
    vm.getPromotionInfo()
  },
  mounted() {
    const vm = this
    vm.getPromotionInfo()

  },
  methods: {
    // 키오스크 정보 호출 API
    getKioskDetail() {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        kioskNo: vm.$route.params.kioskNo
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskDetail.json`

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.kioskInfo = resultData
      })
    },
    // 프로모션 정보 호출 API
    getPromotionInfo() {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        kioskNo: vm.$route.params.kioskNo
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/promotionDetail.json`
      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('정상적으로 처리되지 않았습니다.')
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            if (response.data.resultStatus.messageCode === '4002') {
              kendo.alert(response.data.resultStatus.messageText)
              vm.$router.go(-1)
            } else {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }
          }
          let resultData = response.data.resultData

          vm.promotionInfo = resultData
          vm.promotionList = resultData.promotionInfoList

          resolve(true)
        })
      })
    },
    // 이미지파일 가져오기
    getFileSrc(row){
      if(row.fileSrc === undefined){
        const vm = this
        return `${ApiConfig.eklDomain}/files/2000/${row.fileId}/0?lutk=${vm.loginUserToken}`
      }
      return row.fileSrc
    },
    // 이미지파일 미리보기 설정
    getFileData(fileInfo) {
      const vm = this

      vm.selectedRow.imgFile = fileInfo

      // 미리보기 세팅
      setTimeout(() => {
        const raw = fileInfo[0].rawFile
        const reader = new FileReader()
        const name = fileInfo[0].name
        if (raw) {
          reader.onloadend = function () {
            vm.selectedRow.fileSrc = this.result
            vm.promotionList = vm.promotionList.map((item) => {
              if(item.seqNo === vm.selectedRow.seqNo) {
                return vm.selectedRow
              } else {
                return item
              }
            })
          }
          reader.readAsDataURL(raw)
        }
      })
      // 강제로 img태그의 src를 지정.
    },
    // 프로모션 순서 up
    upSeqNo(row){
      const vm = this
      let targetRow = vm.promotionList[row.seqNo-2]

      // 현재꺼랑, 앞에꺼 swap
      let temp = targetRow.seqNo
      targetRow.seqNo = row.seqNo
      row.seqNo = temp

      vm.promotionList = vm.promotionList.sort((a,b) => {
        if(a.seqNo > b.seqNo) return 1
        if(a.seqNo < b.seqNo) return -1
        return 0;
      })
    },
    // 프로모션 순서 down
    downSeqNo(row){
      const vm = this
      let targetRow = vm.promotionList[row.seqNo]

      // 현재꺼랑, 뒤에꺼 swqp
      let temp = targetRow.seqNo
      targetRow.seqNo = row.seqNo
      row.seqNo = temp

      vm.promotionList = vm.promotionList.sort((a,b) => {
        if(a.seqNo > b.seqNo) return 1
        if(a.seqNo < b.seqNo) return -1
        return 0
      })
    },
    // 프로모션 행 삭제
    onClickDeleteRow(row){
      const vm = this
      kendo.confirm('삭제하시겠습니까?').done(function () {
        vm.promotionList = vm.promotionList.filter(item => (item.seqNo !== row.seqNo))
        vm.deleteList.push(row.prId)
        // seqNo reset
        let i=1
        vm.promotionList.forEach(item => { item.seqNo = i++ })
      })
    },
    // 프로모션 행 추가
    onClickAddRow(){
      const vm = this
      if(vm.promotionList.length >= 5){
        kendo.alert('<p>프로모션은 최대 5개 까지만 등록 가능합니다.<br>기존에 프로모션을 삭제 후 추가해 주세요.</p>')
        return false
      }
      vm.promotionList.push({
        prId: null,
        seqNo: vm.promotionList.length+1,
        fileId: null,
        actionType: 'REDIRECT_MAIN',
        promotionUseYn: 'Y',
        fileInfo: null,
        imgFile: null
      })
    },
    // 프로모션 등록
    onClickSave () {
      const vm = this
      if (EtnersCommonUtil.isEmpty(vm.promotionInfo.promotionDelay) || !EtnersCommonUtil.isPositiveInteger(vm.promotionInfo.promotionDelay)) {
        kendo.alert('프로모션 시간은 1이상의 숫자를 입력해주세요')
        vm.errorTarget = 'promotionDelay'
        return
      }
      if(vm.promotionInfo.kioskPromotionUseYn === 'Y'){
        if(!vm.promotionList.length > 0 || !vm.promotionList.some(item => item.promotionUseYn === 'Y')) {
          kendo.alert('프로모션을 등록하세요')
          vm.errorTarget = null
          return
        }
      }
      vm.errorTarget = null

      const formData = new FormData()
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/promotionUpdate.json`
      const params = {
        loginUserToken : vm.loginUserToken,
        kioskNo: vm.kioskInfo.kioskNo,
        kioskPromotionUseYn : vm.promotionInfo.kioskPromotionUseYn,
        promotionDelay : vm.promotionInfo.promotionDelay,
        promotionList : vm.promotionList,
        deleteList : vm.deleteList
      }
      let nmList = ['pr1', 'pr2', 'pr3', 'pr4', 'pr5']
      let i = 0
      for(let row of vm.promotionList){
        let rawFile = null
        if(!!row.imgFile) {
          rawFile = row.imgFile[0].rawFile
        } else if (!!!row.fileId) {
          kendo.alert('프로모션을 이미지를 첨부해주세요.')
          return
        }
        formData.append(nmList[i++], rawFile)
      }
      formData.append('PromotionUpdateRequestParam', new Blob([JSON.stringify(params)], {
        type: 'application/json',
      }))
      ApiUtil.postIncludeUploadFile(url, formData).then(response => {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
              return false
            }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        kendo.alert('저장되었습니다.')
        vm.redirectToList()
      })
    },
    // 목록으로 이동
    redirectToList() {
      this.$router.push({
        name: "KioskList"
      })
    },
  },

  data: function () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      kioskInfo: {},
      promotionInfo : {
        kioskPromotionUseYn: 'N',
      },
      promotionList:[],
      deleteList: [],
      errorTarget: null,
      selectedRow: null,
    }
  }
}
</script>
